import * as API from './apis';
import Swal from 'sweetalert2';
import { RootState } from '../../domain/models/RootState';
import { PaginatedResponse } from '../../domain/models/PaginatedResponse';
import { Comment } from '../../domain/models/Comment';
import { createAsyncThunkApp } from '../hooks';

export const getAllComment = createAsyncThunkApp<any, any>(
  'HousekeysComments/getAll',
  async ({ housekey_id, page, stackmode = false }, thunkAPI) => {
    try {
      const { auth, housekey_comments }: RootState = thunkAPI.getState();
      const result: PaginatedResponse<Comment> = (
        await API.getAllComments({ housekey_id, page }, auth.token)
      ).data;
      if (
        housekey_comments.housekey_id === housekey_id &&
        stackmode &&
        page !== 1
      ) {
        result.data = [...housekey_comments.comments.data, ...result.data];
      }
      return { response: result, housekey_id };
    } catch (error) {
      throw error;
    }
  }
);

export const updateComment = createAsyncThunkApp<any, any>(
  'HousekeysComments/update',
  async ({ values, text }, thunkAPI) => {
    try {
      const { auth }: RootState = thunkAPI.getState();
      const res = await API.updateComment(values, auth.token);
      Swal.fire({
        icon: 'success',
        title: `${text || 'Editado'} con exito`,
      });
      return res;
    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: `Hubo un error al editar los datos`,
        text: 'intenta de nuevo',
      });
      throw error;
    }
  }
);

export const createComment = createAsyncThunkApp<any, any>(
  'HousekeysComments/create',
  async (comment: any, thunkAPI) => {
    const { auth }: RootState = thunkAPI.getState();
    const res = await API.createComment(comment, auth.token);
    if (res.status === 200) {
      return res.data;
    }
  }
);
